import styled from 'styled-components'

import { CardQuestion } from 'src/components/Typography'
import { media } from 'src/styles/media'

export const ScreenWrap = styled.div<{ bgStart: string; bgEnd: string }>`
  background-image: linear-gradient(
    238deg,
    ${({ bgStart }) => bgStart},
    ${({ bgEnd }) => bgEnd}
  );
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  ${media.desktop} {
    min-height: 49.5rem;
  }
`

export const ImageWrap = styled.div`
  max-height: 28.9rem;
  max-width: 24rem;
`

export const Illustration = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

export const CardTitle = styled(CardQuestion)<{ color: string }>`
  color: ${({ color }) => color};
`
